var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigaAppLoghiMpRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0_rtl {\n        fill: none;\n      }\n\n      .st1_rtl {\n        fill: #fff;\n      }\n\n      .st1_rtl, .st2_rtl {\n        fill-rule: evenodd;\n      }\n\n      .st3_rtl {\n        clip-path: url(#clippath_rtl-1);\n      }\n\n      .st4_rtl {\n        clip-path: url(#clippath_rtl-2);\n      }\n\n      .st5_rtl {\n        fill: red;\n      }\n\n      .st6_rtl {\n        clip-path: url(#clippath_rtl);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath_rtl"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0_rtl",
    x: 343.3,
    y: 344.4,
    width: 287.3,
    height: 287.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath_rtl-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0_rtl",
    d: "M487,344.4c-79.3,0-143.6,64.3-143.6,143.6s64.3,143.6,143.6,143.6,143.6-64.3,143.6-143.6-64.3-143.6-143.6-143.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath_rtl-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0_rtl",
    x: 343.3,
    y: 344.4,
    width: 287.3,
    height: 287.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st6_rtl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5_rtl",
    d: "M343.3,488.1c0-79.3,64.3-143.6,143.6-143.6s143.6,64.3,143.6,143.6-64.3,143.6-143.6,143.6-143.6-64.3-143.6-143.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3_rtl"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2_rtl",
    points: "371.1 403.3 602.9 403.3 487 632.2 371.1 403.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4_rtl"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1_rtl",
    d: "M430.7,442.5h2c4.5,0,8.5.7,8.5,6.3s-4.3,6.1-8.7,6.1h-1.8v-12.3h0ZM401.4,495.2h25.8v-23.3h.5l11.6,23.3h30.4l-15.8-23.6c-1.4-2.1-3.1-3.3-4.4-4.3v-.6c9.8-3.3,14-7.9,14-18.9,0-18.3-13.9-25.2-30.2-25.2h-31.8v72.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1_rtl",
    points: "465.5 446.2 480 445.6 480 495.2 506.4 495.2 506.4 445.6 520.9 446.2 520.9 422.7 465.5 422.7 465.5 446.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1_rtl",
    points: "526.1 495.2 574.5 495.2 574.5 471.9 552.4 471.9 552.4 422.7 526.1 422.7 526.1 495.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_rtl",
    d: "M448.8,518.5c4.8,0,5.7,5.4,5.7,9s-1.2,9.6-5.7,9.6-5.7-6.3-5.7-9.6.9-9,5.7-9M448.8,504.8c-13.3,0-20.9,9.8-20.9,22.2s7.4,23,20.9,23,20.9-9.9,20.9-23-7.7-22.2-20.9-22.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_rtl",
    d: "M511.7,549.4v-13.5l-8.5.5-7.5,1v-.5c7.7-2.4,15.4-7.9,15.4-16.7s-9.7-15.5-18.8-15.5c-13.2,0-18.9,5.7-20.1,18.5h15.6c.1-2.7.5-5.5,3.9-5.5s3.6,1.5,3.6,3.5c0,3.9-6.9,10.1-9.7,12.5l-17.5,15.5h43.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_rtl",
    d: "M525.7,535.5c-4.2,0-8.7,2.7-8.7,7.4s4.4,7.2,8.7,7.2,8.7-2.6,8.7-7.2-4.4-7.4-8.7-7.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1_rtl",
    points: "401.6 520.1 408.4 519.6 408.4 549.4 424.2 549.4 424.2 505.5 401.6 506.2 401.6 520.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_rtl",
    d: "M545,505.5l-3.8,25.9c3.7-1.3,7.7-1.9,11.6-1.9s8.8.8,8.8,4.4-5.1,4.4-7.7,4.4-9.9-1.9-13.1-3.6l-1.7,11.9c4.1,2,12.9,3.5,17.5,3.5,9.3,0,21-5.1,21-15.8s-7-13.7-15-13.7-6,.4-7.4,2.3h-.4c.8-1.6,1.1-3.4,1.4-5.1h18.8v-12.3h-29.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigaAppLoghiMpRtl);
export default __webpack_public_path__ + "static/media/LIGA_APP_loghiMP_RTL.297321319f9930201a8d91a4a8c5b8da.svg";
export { ForwardRef as ReactComponent };